import { Range } from 'slate';

export default function isCollapsed(selection) {
  return !!selection && Range.isCollapsed(selection);
}
